import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Choose shortcut", -1)
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Add", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { PropType, computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store";
import { Shortcut } from "@/models/shortcut";
import { useLoading } from "../common/loading.composable";
import FieldChoice, { Item } from "../common/FieldChoice.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutAddForm',
  props: {
  shortcuts: {
    type: Object as PropType<Shortcut[]>
  }
},
  emits: ["choose", "close"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const props = __props;

const shortcutOptions = computed<Item[]>(() =>
  (props.shortcuts || []).map((s) => {
    return {
      label: s.name,
      value: s
    };
  })
);

const choice = reactive({ value: null });

const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);
  store.dispatch(Actions.GetShortcuts);

  setLoading(false);
});

const emit = __emit;

const choose = () => {
  if (choice.value) {
    emit("choose", choice.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (shortcutOptions.value.length)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _hoisted_2,
        _createVNode(FieldChoice, {
          label: "Shortcut",
          modelValue: choice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((choice.value) = $event)),
          items: shortcutOptions.value
        }, null, 8, ["modelValue", "items"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "confirm",
            type: "button",
            disabled: _unref(loading),
            onClick: choose
          }, _hoisted_7, 8, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})